var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8047 8.33331L16.7138 6.43664C16.8447 6.37317 16.9901 6.34321 17.1362 6.3496C17.2824 6.35599 17.4244 6.39852 17.5489 6.47315C17.6734 6.54778 17.7761 6.65204 17.8474 6.77604C17.9187 6.90003 17.9561 7.03965 17.9562 7.18164V12.8183C17.9561 12.9603 17.9187 13.0999 17.8474 13.2239C17.7761 13.3479 17.6734 13.4522 17.5489 13.5268C17.4244 13.6014 17.2824 13.644 17.1362 13.6504C16.9901 13.6567 16.8447 13.6268 16.7138 13.5633L12.8047 11.6666V8.33331Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0859 5H4.21717C3.2688 5 2.5 5.74619 2.5 6.66667V13.3333C2.5 14.2538 3.2688 15 4.21717 15H11.0859C12.0342 15 12.803 14.2538 12.803 13.3333V6.66667C12.803 5.74619 12.0342 5 11.0859 5Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.93578a5efd9c6cb6e79d11c4bf4bdffc.svg";
export { ForwardRef as ReactComponent };